import z from "zod";

export const userForgotPasswordSchema = z.object({
	email: z.string().email(),
});

export type UserForgotPasswordForm = z.infer<typeof userForgotPasswordSchema>;
